import React, { useId } from 'react';
import classNames from 'classnames';
import { ErrorMessage, useFormikContext } from 'formik';
const Checkbox = ({ children, hideErrorMessage = false, name, ...props }) => {
    const uniqueId = useId();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const { errors, touched } = useFormikContext();
    const hasError = errors[name] && touched[name];
    return (React.createElement("div", { className: classNames('form-element-checkbox', { 'has-error': hasError }) },
        React.createElement("label", { htmlFor: name + '_' + uniqueId },
            React.createElement("input", { type: 'checkbox', name: name, id: name + '_' + uniqueId, ...props }),
            React.createElement("div", null, children)),
        hasError && !hideErrorMessage && (React.createElement("p", { className: 'form-elements-error-message' },
            React.createElement(ErrorMessage, { name: name })))));
};
export default Checkbox;
